export default "__VITE_ASSET__29a60f98__"